import React from 'react'
import { useHistory } from 'react-router-dom'

import {
  FilePdfOutlined,
  FileExcelOutlined,
  FileWordOutlined,
  FileOutlined
} from '@ant-design/icons'

const FileDisplay = (props) => {
  const { files } = props
  return (
    <>
      {files.map((file, index) => {
        return <FileItem key={index} file={file} />
      })}
    </>
  )
}

const FileItem = (props) => {
  const { file } = props
  const history = useHistory()

  const getFileType = (file) => {
    const index = file.url.lastIndexOf('.')
    return file.url.slice(index + 1)
  }

  const handleFileClick = (e) => {
    e.preventDefault()
    // Extract path from URL (remove domain if present)
    let filePath = file.url
    if (filePath.startsWith('http')) {
      const url = new URL(filePath)
      filePath = url.pathname
    }

    // Navigate to preview page
    history.push(`/app/file-preview?path=${encodeURIComponent(filePath)}&provider=local`)
  }

  return (
    <div style={{ width: '100%', marginTop: '6px' }}>
      <FileIcon
        style={{ marginRight: '6px', fontSize: '16px' }}
        fileType={getFileType(file)}
      />
      <a
        style={{ fontSize: '16px', cursor: 'pointer' }}
        onClick={handleFileClick}
        href={file.url}
      >
        {file.name || file.url.split('/').pop()}
      </a>
    </div>
  )
}

const FileIcon = (props) => {
  const { fileType, ...rest } = props

  if (fileType === 'pdf') return <FilePdfOutlined {...rest} />
  else if (fileType === 'docx') return <FileWordOutlined {...rest} />
  else if (fileType === 'xls') return <FileExcelOutlined {...rest} />
  else return <FileOutlined />
}

export default FileDisplay
